/* global _satellite */
import { isAdobeSatelliteTrackingReady } from '../utils';
import cookies from '../utils/cookies';

let SOVENDUS = {};

const MIN_WIDTH_PX = 1024;
const CONTAINER_ID = 'sovendus-container-1';
const TRAFFIC_SOURCE_NUMBER = 3762;
const TRAFFIC_MEDIUM_NUMBER = 7;
const INTEGRATION_TYPE = 'genericScript-1.5.1-hasConsent';
const SOVENDUS_BANNER_IMPRESSION_EVENT = 'sovendus_banner_impression';
const SCRIPT_ID = 'sovendus-flexible-iframe-js';
const SCRIPT_SRC =
  'https://api.sovendus.com/sovabo/common/js/flexibleIframe.js';
const TARGETING_COOKIES_COOKIE = 'OneTrust_TargetingCookies';

SOVENDUS.init = function () {
  if (!hasTargetingConsent()) return;
  if (!window.matchMedia(`(min-width: ${MIN_WIDTH_PX}px)`).matches) return;

  const container = document.getElementById(CONTAINER_ID);
  if (!container) return;

  const orderDataElement = document.getElementById('orderDataObject');
  if (!orderDataElement) return;

  const data = JSON.parse(orderDataElement.textContent);
  if (!data?.order?.order_cart) return;

  const order = mapOrder(data);

  window.sovIframes = window.sovIframes || [];
  window.sovIframes.push({
    trafficSourceNumber: TRAFFIC_SOURCE_NUMBER,
    trafficMediumNumber: TRAFFIC_MEDIUM_NUMBER,
    orderId: order.orderId,
    orderValue: order.orderValue,
    orderCurrency: order.orderCurrency,
    iframeContainerId: CONTAINER_ID,
    integrationType: INTEGRATION_TYPE,
    hasConsent: true,
  });

  trackImpression();
  loadSovendusScriptOnce();
};

function hasTargetingConsent() {
  return cookies.get(TARGETING_COOKIES_COOKIE) === 'YES';
}

function mapOrder(data) {
  const order = data.order || {};
  const cart = order?.order_cart?.cart || {};

  return {
    orderId: String(order.id || ''),
    orderValue: cart?.summary?.grand_total ?? '',
    orderCurrency: cart.currency || '',
  };
}

function trackImpression() {
  if (isAdobeSatelliteTrackingReady()) {
    _satellite.track(SOVENDUS_BANNER_IMPRESSION_EVENT);
  }
}

function loadSovendusScriptOnce() {
  if (document.getElementById(SCRIPT_ID)) return;
  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.type = 'text/javascript';
  script.async = true;
  script.src = SCRIPT_SRC;
  document.head.appendChild(script);
}

export default SOVENDUS;
